import { render } from "./Booking.vue?vue&type=template&id=2bbdc8c2&scoped=true"
import script from "./Booking.vue?vue&type=script&lang=js"
export * from "./Booking.vue?vue&type=script&lang=js"

import "./Booking.vue?vue&type=style&index=0&id=2bbdc8c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bbdc8c2"

export default script